import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import ru from './locales/ru.json';
import pt from './locales/pt.json';
import es from './locales/es.json';
import de from './locales/de.json';
import it from './locales/it.json';
import fr from './locales/fr.json';
import sv from './locales/sv.json';
import no from './locales/no.json';
import fi from './locales/fi.json';
import da from './locales/da.json';
import hi from './locales/hi.json';
import tr from './locales/tr.json';
import uz from './locales/uz.json';
import kk from './locales/kk.json';
import ja from './locales/ja.json';
import ko from './locales/ko.json';

export const SUPPORTED_LANGUAGES = [
    { code: 'en', label: 'EN', flag: '🇬🇧', name: 'English' },
    { code: 'pt', label: 'PT', flag: '🇧🇷', name: 'Português (BR)' },
    { code: 'es', label: 'ES', flag: '🇪🇸', name: 'Español' },
    { code: 'de', label: 'DE', flag: '🇩🇪', name: 'Deutsch' },
    { code: 'it', label: 'IT', flag: '🇮🇹', name: 'Italiano' },
    { code: 'fr', label: 'FR', flag: '🇫🇷', name: 'Français' },
    { code: 'sv', label: 'SV', flag: '🇸🇪', name: 'Svenska' },
    { code: 'no', label: 'NO', flag: '🇳🇴', name: 'Norsk' },
    { code: 'fi', label: 'FI', flag: '🇫🇮', name: 'Suomi' },
    { code: 'da', label: 'DA', flag: '🇩🇰', name: 'Dansk' },
    { code: 'hi', label: 'HI', flag: '🇮🇳', name: 'हिन्दी' },
    { code: 'tr', label: 'TR', flag: '🇹🇷', name: 'Türkçe' },
    { code: 'uz', label: 'UZ', flag: '🇺🇿', name: 'Oʼzbekcha' },
    { code: 'kk', label: 'KK', flag: '🇰🇿', name: 'Қазақша' },
    { code: 'ru', label: 'RU', flag: '🇷🇺', name: 'Русский' },
    { code: 'ja', label: 'JA', flag: '🇯🇵', name: '日本語' },
    { code: 'ko', label: 'KO', flag: '🇰🇷', name: '한국어' },
];

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            ru: { translation: ru },
            pt: { translation: pt },
            es: { translation: es },
            de: { translation: de },
            it: { translation: it },
            fr: { translation: fr },
            sv: { translation: sv },
            no: { translation: no },
            fi: { translation: fi },
            da: { translation: da },
            hi: { translation: hi },
            tr: { translation: tr },
            uz: { translation: uz },
            kk: { translation: kk },
            ja: { translation: ja },
            ko: { translation: ko },
        },
        fallbackLng: 'en',
        supportedLngs: ['en', 'ru', 'pt', 'es', 'de', 'it', 'fr', 'sv', 'no', 'fi', 'da', 'hi', 'tr', 'uz', 'kk', 'ja', 'ko'],
        load: 'languageOnly',
        interpolation: { escapeValue: false },
        detection: {
            order: ['localStorage', 'navigator'],
            caches: ['localStorage'],
            lookupLocalStorage: 'lang',
        },
    });

export default i18n;
